<template>
    <div class="question-item" v-if="show !== false">
        <div class="content">
            <div class="question-title">
                <TextTemplate :text="`${question.indexNo}. ${question.content}`" />
            </div>
            <ImagePreview :picUrl="question.picUrl" v-if="question.picUrl" />
        </div>
        <textarea @blur="onChange" v-model="answer" class="writing-container" placeholder="请输入答案..." />
    </div>
</template>
<script>
import TextTemplate from '../../TextTemplate.vue'
import ImagePreview from '../../ImagePreview.vue'

export default {
    components: { TextTemplate, ImagePreview },
    props: ['show', 'question'],
    data() {
        return {
            answer: '',
        }
    },
    created() {
        if (this.question.stashAnswer) {
            // 防止输入中带有@@
            this.answer = this.question.stashAnswer.join('@@') || ''
        }
        this.updateStoreData()
    },
    methods: {
        onChange() {
            this.updateStoreData('edit')
        },
        updateStoreData(type) {
            const { id } = this.question
            if (type === 'edit') {
                this.$store.dispatch('paperDetails/updateUserAnswer', { id, answer: [this.answer] })
            }
            let data = null
            if (this.answer) {
                data = { state: true, answer: [this.answer] }
            }
            this.$store.dispatch('paperDetails/setUserAnswerMap', { [`q-${id}`]: data })
        },
    },
}
</script>
<style lang="scss" scoped>
.question-item {
    .content {
        height: calc(100% - 188px);
        overflow-y: auto;
    }
}
.writing-container {
    width: 96%;
    margin: 16px auto 12px;
    display: block;
    height: 160px;
    max-height: 160px;
    border: 1px solid #ccc;
    resize: none;
    border-radius: 3px;
    line-height: 1.4em;
    padding: 12px;
    box-sizing: border-box;
    font-size: 14px;
}
</style>
